/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { TrafficFilterRulesetRequest } from '@modules/cloud-api/v1/types'
import type { RulesetType } from '@modules/network-security-lib/types'
import type { CreateTrafficFilterRequest } from '@modules/network-user-api/v1/types'

export function makeBlankHostedRuleset(type: RulesetType): TrafficFilterRulesetRequest {
  return {
    name: '',
    type: type === 'ipFilter' ? 'ip' : 'vpce',
    region: '',
    include_by_default: false,
    rules: [],
  }
}

export function makeBlankServerlessRuleset(): CreateTrafficFilterRequest {
  return {
    name: '',
    type: 'ip',
    region: '',
    include_by_default: false,
    rules: [],
  }
}
